<template>
  <div class="column">
    <div>
      <div v-if="calibrating" class="d-flex subtitle justify-content-center mt-2">
        {{ $t('boxInfo.calibration.status.running') }} (
        <countdown
          v-if="calibrationStart > 0"
          :time="calibrationStart"
          :transform="transform"
          @end="calibrationEnd"
        >
          <template slot-scope="props">
            <div class="headline">
              {{ `${props.minutes}:${props.seconds}` }}
            </div>
          </template>
        </countdown>
        )
      </div>
      <b-button
        v-else-if="!calibrated"
        v-b-modal="'start-calibration-modal'"
        :disabled="processing"
        variant="outline-primary"
        class="btn-fw col-12 p-2"
      >
        <svg-icon
          v-show="!processing"
          size="22"
          name="play"
          class="fill-icon pr-2 icon-primary"
        ></svg-icon>
        <span v-if="!processing">{{ $t('boxInfo.calibration.status.running') }}</span>
        <div v-if="processing">
          <b-spinner small type="grow"></b-spinner>
          <b-spinner small type="grow"></b-spinner>
          <b-spinner small type="grow"></b-spinner>
        </div>
      </b-button>
      <b-modal
        id="start-calibration-modal"
        centered
        hide-header
        hide-footer
        content-class="modalShadow"
        body-class="p-0 shad"
      >
        <div class="card" :class="size ? 'p-5' : 'p-2'">
          <div class="d-flex justify-content-between align-items-center mb-5">
            <h3 class="m-0">{{ $t('boxInfo.calibration.caption') }}</h3>
            <b-button
              variant="transparent"
              class="p-0 text-muted btn-icon-prepend"
              @click="$bvModal.hide('start-calibration-modal')"
            >
              <svg-icon name="x" size="24" class="fill-icon pr-2"></svg-icon>
            </b-button>
          </div>
          <div>
            <h4>{{ $t('boxInfo.calibration.info') }}</h4>
            <h4>{{ $t('boxInfo.calibration.info1') }}</h4>
          </div>
          <div class="d-flex justify-content-between align-items-center mt-4">
            <b-button
              variant="transparent"
              :size="buttonSize"
              @click="$bvModal.hide('start-calibration-modal')"
            >
              {{ $t('button.cancel.label') }}
            </b-button>
            <b-button variant="primary" :size="buttonSize" @click="startCalibrating()">
              {{ $t('boxInfo.calibration.start') }}
            </b-button>
          </div>
        </div>
      </b-modal>
      <b-button v-if="calibrated" variant="outline-success" class="col-10">
        <svg-icon
          v-show="!processing"
          size="22"
          name="check-circle"
          class="fill-icon pr-2 icon-success"
        ></svg-icon>
        {{ $t('boxInfo.calibration.status.done') }}
      </b-button>
      <b-button
        v-if="calibrated"
        v-b-modal="'start-calibration-modal'"
        :disabled="processing"
        variant="outline-primary"
        class="col-2 p-2"
      >
        <svg-icon size="18" name="refresh-cw" class="fill-icon icon-primary"></svg-icon>
      </b-button>
    </div>
  </div>
</template>

<script>
import startCalibration from '@/api/boxinfo/mutations/startCalibration.gql';
import moment from 'moment';
import { vueWindowSizeMixin } from 'vue-window-size';

export default {
  name: 'BoxInfoCalibration',
  mixins: [vueWindowSizeMixin],
  props: {
    item: Object,
  },
  data() {
    return {
      processing: false,
    };
  },
  computed: {
    size() {
      return this.windowWidth > 775;
    },
    buttonSize() {
      return this.size ? 'lg' : 'md';
    },
    calibrating() {
      return this.item.isCalibrated === false;
    },
    calibrated() {
      return this.item.isCalibrated === true;
    },
    calibrationStart() {
      return this.item.calibrationStart
        ? moment(this.item.calibrationStart).add(10, 'm').diff()
        : 0;
    },
  },
  methods: {
    startCalibrating() {
      this.processing = true;
      this.$apollo
        .mutate({
          mutation: startCalibration,
          variables: {
            thingId: this.item.id,
          },
        })
        .then(() => {
          this.$emit('start');
          this.$bvToast.toast(this.$t('boxInfo.calibration.messageStarted'), {
            title: this.$t('toast.success'),
            variant: 'success',
            solid: true,
          });
          this.$bvModal.hide('start-calibration-modal');
        })
        .catch((e) => console.log(e))
        .finally(() => {
          this.processing = false;
        });
    },
    calibrationEnd() {
      setInterval(() => {
        this.$emit('end');
      }, 10000);
    },
    transform(props) {
      Object.entries(props).forEach(([key, value]) => {
        const digits = value < 10 ? `0${value}` : value;
        props[key] = `${digits}`;
      });
      return props;
    },
  },
};
</script>
